var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSubscriptions(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "22px",
    viewBox: "0 0 27 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icSubscriptions") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.6545296,520.678386 C46.6029883,520.678386 45.709654,521.528361 45.709654,522.644029 C45.709654,523.015517 45.8149271,523.334107 45.9725393,523.5998 L40.9789077,528.753148 C39.6127366,526.521814 38.7194023,523.228311 38.2459708,521.049875 C38.9816929,520.678386 39.5074636,519.934809 39.5074636,519.031335 C39.5074636,517.809871 38.5088562,516.8 37.2997026,516.8 C36.0911438,516.8 35.0919417,517.809871 35.0919417,519.031335 C35.0919417,519.934809 35.6177123,520.678386 36.3534344,521.049875 C35.8805977,523.228311 34.9866686,526.521814 33.6199028,528.753148 L28.6268659,523.5998 C28.7844781,523.334107 28.8897512,523.015517 28.8897512,522.644029 C28.8897512,521.581259 28.0487561,520.678386 26.9448756,520.678386 C25.8409951,520.678386 25,521.528361 25,522.644029 C25,523.706197 25.8409951,524.609671 26.9448756,524.609671 L30.5188076,536.827911 C30.5717415,537.040705 30.7822877,537.2 31.0445782,537.2 L43.6071662,537.2 C43.8177123,537.2 44.0276637,537.040705 44.1329368,536.827911 L47.6545296,524.556172 C48.7060709,524.556172 49.6,523.706197 49.6,522.59053 C49.5470661,521.528361 48.7060709,520.678386 47.6545296,520.678386",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-8-Copy-13",
    transform: "translate(-24.000000, -516.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icSubscriptions",
    stroke: "#333333",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSubscriptions);
export default __webpack_public_path__ + "static/media/icSubscriptions.2b3d01b5bf9d7c54372e922bddf5dcaa.svg";
export { ForwardRef as ReactComponent };